module.exports = __webpack_public_path__ + "img/Company_profile.8cc3fcc6.png";